
























































import {Component, Vue, Watch} from "vue-property-decorator";
import {groupList, createGroup, updateGroup, deleteGroup} from "@/api/team/team";

@Component
export default class Group extends Vue {
    private dataList: object[] = [];
    private selectGroup: object = {};
    private modify = false;
    private title = "创建小队";
    private type;
    private deleteModal = false;

    private params: object = {
        name: ""
    };

    private columnsSchema: object[] = [
        {
            title: "选择",
            align: "center",
            width: "85",
            render: (h, params) => {
                this.dataList.push(params.row);
                return h("div", [
                    h("Checkbox", {
                        props: {
                            value: params.row.checked
                        },
                        on: {
                            "on-change": (e) => {
                                this.dataList.forEach(items => {
                                    //先取消所有对象的勾选，checkBox设置为false
                                    this.$set(items, "checked", false);
                                    if((items as any).group_id == params.row.group_id){
                                        (items as any).checked = true
                                    }else{
                                        (items as any).checked = false
                                    }
                                });
                                if (e) {
                                    this.select(params.row)
                                } else {
                                    this.select(null)
                                }
                                // //再将勾选的对象的checkBox设置为true
                                // (this.dataList[params.index] as any).checked = e;
                                // if (e) {
                                //     this.select(this.dataList[params.index])
                                // } else {
                                //     this.select(null)
                                // }
                            }
                        }
                    })
                ]);
            }
        },
        {
            title: "小队名称",
            key: "name",
            align: "center",
            width: 145,
        },
        {
            title: "小队 ID",
            key: "group_id",
            align: "center",
            slot: "format_id",
            width: 145,
        },
        {
            title: "初级标注员",
            key: "0",
            align: "center",
            width: 145,
        },
        {
            title: "高级标注员",
            key: "2",
            align: "center",
            width: 145,
        },
        {
            title: "审核员",
            key: "3",
            align: "center",
            width: 145,
        },
        {
            title: "高级审核员",
            key: "4",
            align: "center",
            width: 145,
        },
        {
            title: "小助手",
            key: "5",
            align: "center",
            width: 145,
        },
        {
            title: "质检员",
            key: "6",
            align: "center",
            width: 145,
        },
    ];

    private created() {
        this.getList();
    }

    private select(select) {
        this.selectGroup = select
        console.log(this.selectGroup)
    }

    private async getList() {
        try {
            const data = (await groupList()) as any;
            this.$nextTick(() => {
                this.dataList = data.result;
            });
        } catch (error) {
            console.log(error);
        }
    }

    private newName(e) {
        this.params["name"] = e;
    }

    private async handleToChange() {
        if (this.type == 1) {
            const res = (await createGroup(JSON.parse(JSON.stringify(this.params)))) as any;
            if (res.code == 200) {
                this.modify = false;
                this.selectGroup = null
                this.getList();
            } else {
                this.$Message.success(res.message);
            }
        } else if (this.type == 2) {
            this.params["id"] = (this.selectGroup as any).group_id
            const res = (await updateGroup(JSON.parse(JSON.stringify(this.params)))) as any;
            if (res.code == 200) {
                this.modify = false;
                this.selectGroup = null
                this.getList();
            } else {
                this.$Message.success(res.message);
            }
        }
    }

    private addGroup() {
        this.modify = true;
        this.title = "创建小队";
        this.type = 1;
    }

    private updateGroup() {
        if (!this.selectGroup || !(this.selectGroup as any).group_id) {
            this.$Message.error("请选择一个小队进行编辑");
            return
        }
        this.modify = true;
        this.title = "修改小队";
        this.type = 2;
    }

    private deleteGroup() {
        if (!this.selectGroup || !(this.selectGroup as any).group_id) {
            this.$Message.error("请选择一个小队");
            return
        }
        this.deleteModal = true;
    }

    private async deleteModalClick() {
        this.params["id"] = (this.selectGroup as any).group_id
        const res = (await deleteGroup(JSON.parse(JSON.stringify(this.params)))) as any;
        if (res.code == 200) {
            this.deleteModal = false;
            this.selectGroup = null
            this.getList();
        } else {
            this.$Message.success(res.message);
        }
    }
}
